export default __webpack_public_path__ + "static/media/cooperfiresafety.3886639e.jpeg";